// extracted by mini-css-extract-plugin
export default {"pluginpreview":"pluginpreview_eced7e9afeb561cd033c","description":"description_f3e8b46872fc48735840","section":"section_bdc0be3b5513fd8f5b47","title":"title_dc02adeb21a13e995f65"};